import JobPostPage from "@components/job-post-page";
import { loadTranslation } from "@lib/utils";
import { GetStaticPaths, GetStaticProps } from "next";
import { t } from "@lingui/macro";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import {
  Position,
  positionAvailable,
} from "@components/careers-page/job-available";

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  const translation = await loadTranslation(
    locale,
    process.env.NODE_ENV == "production"
  );

  const position = positionAvailable.find((pos) =>
    params?.name?.toString().toLowerCase().includes(pos.position.toLowerCase())
  )?.position;

  if (!position) {
    return {
      notFound: true,
    };
  }

  return { props: { translation, locale, position } };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths =
    positionAvailable.map(({ position }) => ({
      params: { name: position },
    })) || [];

  return {
    paths,
    fallback: "blocking",
  };
};

const JobPost: React.FunctionComponent<{ position: string }> = ({
  position,
}) => {
  const router = useRouter();
  const { locale } = router;

  const selectedPosition = positionAvailable.find((pos) =>
    position.toLowerCase().includes(pos.position.toLowerCase())
  );

  const seoTitle = t`Lumi News Careers`;
  const seoLocale = "/" + locale;

  const title = seoTitle.concat(" | ", selectedPosition?.title[locale]);
  const description = selectedPosition?.seoDescription[locale];

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          url: `https://luminews.my${
            seoLocale.includes("en") ? "" : seoLocale
          }${router.asPath}`,
          title: title,
          description: description,
          images: [
            {
              url: `${selectedPosition?.seoImage}`,
              alt: title,
            },
          ],
        }}
      />
      {selectedPosition && <JobPostPage selectedPosition={selectedPosition} />}
    </>
  );
};

export default JobPost;
